export * from './DefaultVariation';
